import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Session } from "types/generated";

const SessionsTableTypeCell = ({
  item: session,
  ...cellProps
}: TableSimpleCellProps<Pick<Session, "type">>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{session.type}</TableCellText>
    </TableSimpleCell>
  );
};

export default SessionsTableTypeCell;
